module.exports = __webpack_public_path__ + "static/images/jf-border.0ab26e9.png";